import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const OpenInFullIcon = (props: IconProps) => (
  <Icon width="20px" height="20px" viewBox="0 0 20 20" fill="none" {...props}>
    <g id="open_in_full">
      <path
        id="Vector"
        d="M17.5 9.16667V2.5H10.8333L13.575 5.24167L5.24167 13.575L2.5 10.8333V17.5H9.16667L6.425 14.7583L14.7583 6.425L17.5 9.16667Z"
        fill="white"
      />
    </g>
  </Icon>
);

export default memo(OpenInFullIcon);
